<p-autoComplete [dropdown]="true"class="assign" [suggestions]="searchTextResult" (completeMethod)="search($event)" [placeholder]="placeHolderText"
  field="name">
  <ng-template let-ref pTemplate="item">
    <span style="font-size:16px">{{ref.name}}</span>
    <span class="driver-eta">{{ref.eta}}</span>
  </ng-template>
</p-autoComplete>